module.exports = __webpack_public_path__ + "img/login.12b2b5b2.svg";